import { FilterOption } from '@lib/utils/course-filters'

type CourseFilterCheckboxListProps = {
  name: string
  options: FilterOption[]
  selectedValues: string[]
  onToggle: (value: string) => void
  twoColumn?: boolean
}

const renderOption = (
  option: FilterOption,
  name: string,
  selectedValues: string[],
  onToggle: (value: string) => void
) => {
  const isSelected = selectedValues.includes(option.value)
  return (
    <li key={option.value}>
      <label className="flex items-start gap-2 py-1 px-1 rounded cursor-pointer hover:bg-grey-100 text-grey-900 font-500">
        <input
          type="checkbox"
          className="form-checkbox text-orange rounded cursor-pointer h-4 w-4 flex-shrink-0 mt-1"
          checked={isSelected}
          onChange={() => onToggle(option.value)}
          name={`${name}-${option.value}`}
        />
        <span className="break-words">{option.label}</span>
      </label>
    </li>
  )
}

const CourseFilterCheckboxList = ({
  name,
  options,
  selectedValues,
  onToggle,
  twoColumn = false,
}: CourseFilterCheckboxListProps) => {
  if (!twoColumn) {
    return (
      <ul className="list-none pl-0 m-0 space-y-1">
        {options.map((option) =>
          renderOption(option, name, selectedValues, onToggle)
        )}
      </ul>
    )
  }

  const midpoint = Math.ceil(options.length / 2)
  const columns = [options.slice(0, midpoint), options.slice(midpoint)]

  return (
    <div className="flex flex-col sm:flex-row gap-x-4">
      {columns.map((columnOptions, index) => (
        <ul key={index} className="list-none pl-0 m-0 space-y-1 flex-1">
          {columnOptions.map((option) =>
            renderOption(option, name, selectedValues, onToggle)
          )}
        </ul>
      ))}
    </div>
  )
}

export default CourseFilterCheckboxList
